const ServiceOrderStatusEnum = {
  UNFINISHED: 1,
  PAYMENT: 2,
  COMPLETED: 3,
  CANCELED: 4
}
export default ServiceOrderStatusEnum


// WEBPACK FOOTER //
// ./src/enum/serviceOrderStatusEnum.js